export default __webpack_public_path__ + "static/media/apartment-hunt.2d46aa96.png";